import React, { useEffect } from "react";
import $ from "jquery";
import _ from "lodash";

const AmenitesListPopUp = ({ community }) => {
  // console.log(community, "community");

  // Check if community exists before accessing its properties
  if (!community) {
    return <div>Loading amenities...</div>;
  }

  const appartmentAmenities =
    community.AmenitiesList != null && community.AmenitiesList != undefined
      ? JSON.parse(community.AmenitiesList)
      : community.AmenitiesList;
  const apparmentamenites =
    appartmentAmenities != null && appartmentAmenities != undefined
      ? _.filter(appartmentAmenities, function (o) {
          return o.communityname == "Unit";
        })
      : [];
  const communityamenites =
    appartmentAmenities != null && appartmentAmenities != undefined
      ? _.filter(appartmentAmenities, function (o) {
          return o.communityname == "Community";
        })
      : [];
  return (
    <div>
      <div className="SAweb_amenities ">
        <ul className="nav nav-tabs">
          <li className="active">
            <a data-toggle="tab" href="#tab1">
              Community Amenities
            </a>
          </li>
          <li>
            <a data-toggle="tab" href="#tab2">
              Apartment Amenities
            </a>
          </li>
        </ul>

        <div className="tab-content">
          <div id="tab1" className="tab-pane fade in active">
            <div className="box">
              {communityamenites.map((row, index) => {
                return (
                  <div className="item" key={index}>
                    <img
                      src={
                        s3BucketUrl +
                        "Amenities/" +
                        row.aparment_amenity_name.replace(/[^A-Z0-9]+/gi, "") +
                        ".png"
                      }
                      width="55px"
                      alt=""
                    />
                    <span>{row.aparment_amenity_name}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div id="tab2" className="tab-pane fade">
            <div className="box">
              {apparmentamenites.map((row, index) => {
                return (
                  <div className="item" key={index}>
                    <img
                      src={
                        s3BucketUrl +
                        "Amenities/" +
                        row.aparment_amenity_name.replace(/[^A-Z0-9]+/gi, "") +
                        ".png"
                      }
                      width="55px"
                      alt=""
                    />
                    <span>{row.aparment_amenity_name}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AmenitesListPopUp;
